import { useDispatch } from 'react-redux';
import { performSelectionSearch } from '../project-actions';
import useQueryString from '../../components/hooks/useQueryString';
import { useEffect, useRef, useState } from 'react';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import { ProjectEmbeddedComponentWrapper } from './ProjectEmbeddedComponentWrapper';
import styles from './embed-search-project.module.less';

const EmbedSearchProject = () => {
    const dispatch = useDispatch();
    const [isSearching, setIsSearching] = useState(true);
    const [projectIds, setProjectIds] = useState([]);
    const [{ organizationNumber, minAmount = 0, templateId, max = 50 }] = useQueryString();
    const abortController = useRef(null);

    useEffect(() => {
        abortController.current = new AbortController();
        const abortSignal = abortController.current.signal;
        dispatch(
            performSelectionSearch({
                organizationNumbers: organizationNumber ? [organizationNumber] : undefined,
                minAmount,
                randomizeProjects: true,
                activeFirst: true,
                max,
                templateIds: templateId ? [templateId] : undefined,
                signal: abortSignal,
            })
        ).then((result) => {
            if (!result || result?.abortSignal?.aborted) {
                setIsSearching(false);
                setProjectIds([]);
            } else {
                const { projectIds } = result;
                setProjectIds(projectIds);
                setIsSearching(false);
            }
        });
    }, [organizationNumber, minAmount, templateId, max, dispatch]);

    if (isSearching) {
        return <LoaderBar />;
    }

    const components = projectIds.map((projectId) => (
        <ProjectEmbeddedComponentWrapper key={projectId} projectId={projectId} />
    ));
    return <div className={styles.searchContainer}>{components}</div>;
};

export default EmbedSearchProject;
